
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/properties/[listingAlias]/listing",
      function () {
        return require("private-next-pages/properties/[listingAlias]/listing/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/properties/[listingAlias]/listing"])
      });
    }
  